export const FORM_EDITOR_DATE_FORMATS = ['MM-DD-YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'];
export const FORM_EDITOR_DATE_FORMAT_SEPARATORS = {
  '-': 'DASHES',
  '/': 'SLASHES',
  ' ': 'SPACES',
  '.': 'DOTS'
};
export const FALLBACK_DATE_FORMAT = 'YYYY-MM-DD';
export const FALLBACK_DATE_SEPARATOR = '-';